var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { objFlyover } from "./utils/objFlyover";
import { defaultRendererConfig } from "./index";
export function objFlyover1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "OBJ Flyover 1" +
                "</h1>" +
                "<p>" +
                "The camera will be looking at an OBJ object. It should render normally." +
                "</p>";
        const objPos = { longitude: 2.633667667706, latitude: -0.60151043, height: 0 };
        yield objFlyover(defaultRendererConfig(container), {
            url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/pano/textured_output.obj",
        }, objPos);
    });
}
